<!-- @format -->

<h3>{{ "PROFILE.PAYMENTS.TAB_TITLE" | translate }}</h3>
@for (entry of currentAndFuturePayments | keyvalue: reverseKeyOrder; track entry) {
  <div class="study-year">
    <h4 data-cy="current-and-future-payments-table-header">{{
      "PROFILE.PAYMENTS.TABLE.STUDY_YEAR" | translate: { years: entry.key | studyYearName }
    }}</h4>
    <app-study-year-payments [payments]="entry.value" [level]="5"></app-study-year-payments>
  </div>
}
@if (pastPayments.size > 0) {
  <sis-expandable [title]="'PROFILE.PAYMENTS.PAST_STUDY_YEARS' | translate" [level]="4">
    <ng-template sisExpandableContent>
      @for (entry of pastPayments | keyvalue: reverseKeyOrder; track entry) {
        <div class="study-year">
          <h5 class="fudis-heading__md sis-mb-md">{{
            "PROFILE.PAYMENTS.TABLE.STUDY_YEAR" | translate: { years: entry.key | studyYearName }
          }}</h5>
          <app-study-year-payments [level]="6" [payments]="entry.value"></app-study-year-payments>
        </div>
      }
    </ng-template>
  </sis-expandable>
}
